/* eslint-disable import/no-unresolved */
import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import ContextDevTool from 'react-context-devtool';
import classInstanceReducer, { initialState } from '../reducers/classInstanceReducer';

export const ClassInstanceContext = createContext();

const ClassInstanceProvider = ({ children }) => {
  const useClassInstanceState = useReducer(classInstanceReducer, initialState);

  return (
    <ClassInstanceContext.Provider value={[...useClassInstanceState]}>
      <ContextDevTool
        context={ClassInstanceContext}
        id="ClassInstanceContext"
        displayName="ClassInstance Context"
      />
      {children}
    </ClassInstanceContext.Provider>
  );
};

ClassInstanceProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ClassInstanceProvider;
